<template>
  <b-modal title="Informações do Serviço" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Cliente:" label-for="cliente" label-cols="3" label-align-sm="right">
            <b-form-select v-model="editing.cliente">
              <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
                >{{ cliente.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Descrição:"
            label-for="descricao"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-textarea v-model="editing.descricao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="" label-align-sm="right" label-for="data">
            <b-form-checkbox v-model="editing.concluido" name="check-button" switch class="pt-2">
              Serviço Concluído <b>(Checked: {{ editing.concluido }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useAvulsoStore } from "@/stores/AvulsoStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { storeToRefs } from "pinia";
import Avulso from "@/models/Avulso";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ModalDeEdicaoDeAvulso",

  data() {
    return {
      show: false,
      editing: new Avulso(0, "Novo Serviço", new Date(), false, false),
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.avulsoStore.ALTERAR_AVULSO(this.editing).then(() => {
          this.store.NOTIFICAR(
            new Notificacao("Serviço avulso salvo no SGCQ com sucesso!", "Excelente!", "success")
          );
        });
      } else {
        this.avulsoStore
          .CADASTRAR_AVULSO(this.editing)
          .then(() =>
            this.store.NOTIFICAR(
              new Notificacao("Serviço avulso salvo no SGCQ com sucesso!", "Excelente!", "success")
            )
          );
      }
      this.show = !this.show;
    },

    call(avulso) {
      this.show = !this.show;
      this.editing = avulso;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const { getFilterClientes } = storeToRefs(clienteStore);
    const avulsoStore = useAvulsoStore();

    return {
      store,
      clienteStore,
      getFilterClientes,
      avulsoStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
